(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1880],{

/***/ 44133:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 5257:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(5257),
    isIterateeCall = __webpack_require__(42451),
    toFinite = __webpack_require__(19557);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 32216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(51378);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 19557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(27273);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 86628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Ot; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
function e(){return(e=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}const n=(/* unused pure expression or super */ null && (["children","options"])),r=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","className","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((t,e)=>(t[e.toLowerCase()]=e,t),{for:"htmlFor"}),o={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},c=["style","script"],a=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,u=/mailto:/i,i=/\n{2,}$/,l=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,s=/^ *> ?/gm,_=/^ {2,}\n/,f=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,d=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,p=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,g=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,m=/^(?:\n *)*\n/,y=/\r\n?/g,h=/^\[\^([^\]]+)](:.*)\n/,k=/^\[\^([^\]]+)]/,x=/\f/g,b=/^\s*?\[(x|\s)\]/,v=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,S=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,$=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,w=/&([a-z]+);/g,z=/^<!--[\s\S]*?(?:-->)/,E=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,A=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,R=/^\{.*\}$/,I=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,M=/^<([^ >]+@[^ >]+)>/,O=/^<([^ >]+:\/[^ >]+)>/,B=/ *\n+$/,L=/(?:^|\n)( *)$/,T=/-([a-z])?/gi,j=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,C=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,D=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,N=/^\[([^\]]*)\] ?\[([^\]]*)\]/,Z=/(\[|\])/g,F=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,P=/\t/g,G=/^ *\| */,H=/(^ *\||\| *$)/g,q=/ *$/,U=/^ *:-+: *$/,V=/^ *:-+ *$/,W=/^ *-+: *$/,Q=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,X=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,J=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,K=/^\\([^0-9A-Za-z\s])/,Y=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,tt=/^\n+/,et=/^([ \t]*)/,nt=/\\([^0-9A-Z\s])/gi,rt=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +"),ot=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +[^\\n]*(?:\\n(?!\\1(?:[*+-]|\\d+\\.) )[^\\n]*)*(\\n|$)","gm"),ct=new RegExp("^( *)((?:[*+-]|\\d+\\.)) [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1(?:[*+-]|\\d+\\.) (?!(?:[*+-]|\\d+\\.) ))\\n*|\\s*\\n*$)"),at="(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*",ut=new RegExp("^\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),it=new RegExp("^!\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),lt=[l,p,d,v,S,z,ot,ct,j],st=[...lt,/^[^\n]+(?:  \n|\n{2,})/,$,A];function _t(t){return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function ft(t){return W.test(t)?"right":U.test(t)?"center":V.test(t)?"left":null}function dt(t,e,n){const r=n.t;n.t=!0;const o=e(t.trim(),n);n.t=r;let c=[[]];return o.forEach(function(t,e){"tableSeparator"===t.type?0!==e&&e!==o.length-1&&c.push([]):("text"!==t.type||null!=o[e+1]&&"tableSeparator"!==o[e+1].type||(t.content=t.content.replace(q,"")),c[c.length-1].push(t))}),c}function pt(t,e,n){n.o=!0;const r=dt(t[1],e,n),o=t[2].replace(H,"").split("|").map(ft),c=function(t,e,n){return t.trim().split("\n").map(function(t){return dt(t,e,n)})}(t[3],e,n);return n.o=!1,{align:o,cells:c,header:r,type:"table"}}function gt(t,e){return null==t.align[e]?{}:{textAlign:t.align[e]}}function mt(t){return function(e,n){return n.o?t.exec(e):null}}function yt(t){return function(e,n){return n.o||n.u?t.exec(e):null}}function ht(t){return function(e,n){return n.o||n.u?null:t.exec(e)}}function kt(t){return function(e){return t.exec(e)}}function xt(t,e,n){if(e.o||e.u)return null;if(n&&!n.endsWith("\n"))return null;let r="";t.split("\n").every(t=>!lt.some(e=>e.test(t))&&(r+=t+"\n",t.trim()));const o=r.trimEnd();return""==o?null:[r,o]}function bt(t){try{if(decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data):/i))return null}catch(t){return null}return t}function vt(t){return t.replace(nt,"$1")}function St(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!0,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function $t(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!1,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function wt(t,e,n){return n.o=!1,t(e+"\n\n",n)}const zt=(t,e,n)=>({content:St(e,t[1],n)});function Et(){return{}}function At(){return null}function Rt(...t){return t.filter(Boolean).join(" ")}function It(t,e,n){let r=t;const o=e.split(".");for(;o.length&&(r=r[o[0]],void 0!==r);)o.shift();return r||n}var Mt;function Ot(n,H={}){H.overrides=H.overrides||{},H.slugify=H.slugify||_t,H.namedCodesToUnicode=H.namedCodesToUnicode?e({},o,H.namedCodesToUnicode):o;const q=H.createElement||react__WEBPACK_IMPORTED_MODULE_0__.createElement;function U(t,n,...r){const o=It(H.overrides,`${t}.props`,{});return q(function(t,e){const n=It(e,t);return n?"function"==typeof n||"object"==typeof n&&"render"in n?n:It(e,`${t}.component`,t):t}(t,H.overrides),e({},n,o,{className:Rt(null==n?void 0:n.className,o.className)||void 0}),...r)}function V(e){let n=!1;H.forceInline?n=!0:H.forceBlock||(n=!1===F.test(e));const r=dt(ft(n?e:`${e.trimEnd().replace(tt,"")}\n\n`,{o:n}));for(;"string"==typeof r[r.length-1]&&!r[r.length-1].trim();)r.pop();if(null===H.wrapper)return r;const o=H.wrapper||(n?"span":"div");let c;if(r.length>1||H.forceWrapper)c=r;else{if(1===r.length)return c=r[0],"string"==typeof c?U("span",{key:"outer"},c):c;c=null}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(o,{key:"outer"},c)}function W(e){const n=e.match(a);return n?n.reduce(function(e,n,o){const c=n.indexOf("=");if(-1!==c){const a=function(t){return-1!==t.indexOf("-")&&null===t.match(E)&&(t=t.replace(T,function(t,e){return e.toUpperCase()})),t}(n.slice(0,c)).trim(),u=function(t){const e=t[0];return('"'===e||"'"===e)&&t.length>=2&&t[t.length-1]===e?t.slice(1,-1):t}(n.slice(c+1).trim()),i=r[a]||a,l=e[i]=function(t,e){return"style"===t?e.split(/;\s?/).reduce(function(t,e){const n=e.slice(0,e.indexOf(":"));return t[n.replace(/(-[a-z])/g,t=>t[1].toUpperCase())]=e.slice(n.length+1).trim(),t},{}):"href"===t?bt(e):(e.match(R)&&(e=e.slice(1,e.length-1)),"true"===e||"false"!==e&&e)}(a,u);"string"==typeof l&&($.test(l)||A.test(l))&&(e[i]=react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(V(l.trim()),{key:o}))}else"style"!==n&&(e[r[n]||n]=!0);return e},{}):void 0}const nt=[],at={},lt={blockQuote:{i:ht(l),l:Mt.HIGH,_:(t,e,n)=>({content:e(t[0].replace(s,""),n)}),p:(t,e,n)=>U("blockquote",{key:n.g},e(t.content,n))},breakLine:{i:kt(_),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("br",{key:n.g})},breakThematic:{i:ht(f),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("hr",{key:n.g})},codeBlock:{i:ht(p),l:Mt.MAX,_:t=>({content:t[0].replace(/^ {4}/gm,"").replace(/\n+$/,""),lang:void 0}),p:(t,e,n)=>U("pre",{key:n.g},U("code",{className:t.lang?`lang-${t.lang}`:""},t.content))},codeFenced:{i:ht(d),l:Mt.MAX,_:t=>({content:t[3],lang:t[2]||void 0,type:"codeBlock"})},codeInline:{i:yt(g),l:Mt.LOW,_:t=>({content:t[2]}),p:(t,e,n)=>U("code",{key:n.g},t.content)},footnote:{i:ht(h),l:Mt.MAX,_:t=>(nt.push({footnote:t[2],identifier:t[1]}),{}),p:At},footnoteReference:{i:mt(k),l:Mt.HIGH,_:t=>({content:t[1],target:`#${H.slugify(t[1])}`}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target)},U("sup",{key:n.g},t.content))},gfmTask:{i:mt(b),l:Mt.HIGH,_:t=>({completed:"x"===t[1].toLowerCase()}),p:(t,e,n)=>U("input",{checked:t.completed,key:n.g,readOnly:!0,type:"checkbox"})},heading:{i:ht(v),l:Mt.HIGH,_:(t,e,n)=>({content:St(e,t[2],n),id:H.slugify(t[2]),level:t[1].length}),p:(t,e,n)=>(t.tag=`h${t.level}`,U(t.tag,{id:t.id,key:n.g},e(t.content,n)))},headingSetext:{i:ht(S),l:Mt.MAX,_:(t,e,n)=>({content:St(e,t[1],n),level:"="===t[2]?1:2,type:"heading"})},htmlComment:{i:kt(z),l:Mt.HIGH,_:()=>({}),p:At},image:{i:yt(it),l:Mt.HIGH,_:t=>({alt:t[1],target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt||void 0,title:t.title||void 0,src:bt(t.target)})},link:{i:mt(ut),l:Mt.LOW,_:(t,e,n)=>({content:$t(e,t[1],n),target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target),title:t.title},e(t.content,n))},linkAngleBraceStyleDetector:{i:mt(O),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],type:"link"})},linkBareUrlDetector:{i:(t,e)=>e.m?null:mt(I)(t,e),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],title:void 0,type:"link"})},linkMailtoDetector:{i:mt(M),l:Mt.MAX,_(t){let e=t[1],n=t[1];return u.test(n)||(n="mailto:"+n),{content:[{content:e.replace("mailto:",""),type:"text"}],target:n,type:"link"}}},list:{i(t,e,n){const r=L.exec(n);return!r||!e.h&&e.o?null:ct.exec(t=r[1]+t)},l:Mt.HIGH,_(t,e,n){const r=t[2],o=r.length>1,c=o?+r:void 0,a=t[0].replace(i,"\n").match(ot);let u=!1;return{items:a.map(function(t,r){const o=rt.exec(t)[0].length,c=new RegExp("^ {1,"+o+"}","gm"),i=t.replace(c,"").replace(rt,""),l=r===a.length-1,s=-1!==i.indexOf("\n\n")||l&&u;u=s;const _=n.o,f=n.h;let d;n.h=!0,s?(n.o=!1,d=i.replace(B,"\n\n")):(n.o=!0,d=i.replace(B,""));const p=e(d,n);return n.o=_,n.h=f,p}),ordered:o,start:c}},p:(t,e,n)=>U(t.ordered?"ol":"ul",{key:n.g,start:t.start},t.items.map(function(t,r){return U("li",{key:r},e(t,n))}))},newlineCoalescer:{i:ht(m),l:Mt.LOW,_:Et,p:()=>"\n"},paragraph:{i:xt,l:Mt.LOW,_:zt,p:(t,e,n)=>U("p",{key:n.g},e(t.content,n))},ref:{i:mt(C),l:Mt.MAX,_:t=>(at[t[1]]={target:t[2],title:t[4]},{}),p:At},refImage:{i:yt(D),l:Mt.MAX,_:t=>({alt:t[1]||void 0,ref:t[2]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt,src:bt(at[t.ref].target),title:at[t.ref].title})},refLink:{i:mt(N),l:Mt.MAX,_:(t,e,n)=>({content:e(t[1],n),fallbackContent:e(t[0].replace(Z,"\\$1"),n),ref:t[2]}),p:(t,e,n)=>at[t.ref]?U("a",{key:n.g,href:bt(at[t.ref].target),title:at[t.ref].title},e(t.content,n)):U("span",{key:n.g},e(t.fallbackContent,n))},table:{i:ht(j),l:Mt.HIGH,_:pt,p:(t,e,n)=>U("table",{key:n.g},U("thead",null,U("tr",null,t.header.map(function(r,o){return U("th",{key:o,style:gt(t,o)},e(r,n))}))),U("tbody",null,t.cells.map(function(r,o){return U("tr",{key:o},r.map(function(r,o){return U("td",{key:o,style:gt(t,o)},e(r,n))}))})))},tableSeparator:{i:function(t,e){return e.t?G.exec(t):null},l:Mt.HIGH,_:function(){return{type:"tableSeparator"}},p:()=>" | "},text:{i:kt(Y),l:Mt.MIN,_:t=>({content:t[0].replace(w,(t,e)=>H.namedCodesToUnicode[e]?H.namedCodesToUnicode[e]:t)}),p:t=>t.content},textBolded:{i:yt(Q),l:Mt.MED,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("strong",{key:n.g},e(t.content,n))},textEmphasized:{i:yt(X),l:Mt.LOW,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("em",{key:n.g},e(t.content,n))},textEscaped:{i:yt(K),l:Mt.HIGH,_:t=>({content:t[1],type:"text"})},textStrikethroughed:{i:yt(J),l:Mt.LOW,_:zt,p:(t,e,n)=>U("del",{key:n.g},e(t.content,n))}};!0!==H.disableParsingRawHTML&&(lt.htmlBlock={i:kt($),l:Mt.HIGH,_(t,e,n){const[,r]=t[3].match(et),o=new RegExp(`^${r}`,"gm"),a=t[3].replace(o,""),u=(i=a,st.some(t=>t.test(i))?wt:St);var i;const l=t[1].toLowerCase(),s=-1!==c.indexOf(l);n.m=n.m||"a"===l;const _=s?t[3]:u(e,a,n);return n.m=!1,{attrs:W(t[2]),content:_,noInnerParse:s,tag:s?l:t[1]}},p:(t,n,r)=>U(t.tag,e({key:r.g},t.attrs),t.noInnerParse?t.content:n(t.content,r))},lt.htmlSelfClosing={i:kt(A),l:Mt.HIGH,_:t=>({attrs:W(t[2]||""),tag:t[1]}),p:(t,n,r)=>U(t.tag,e({},t.attrs,{key:r.g}))});const ft=function(t){let e=Object.keys(t);function n(r,o){let c=[],a="";for(;r;){let u=0;for(;u<e.length;){const i=e[u],l=t[i],s=l.i(r,o,a);if(s){const t=s[0];r=r.substring(t.length);const e=l._(s,n,o);null==e.type&&(e.type=i),c.push(e),a=t;break}u++}}return c}return e.sort(function(e,n){let r=t[e].l,o=t[n].l;return r!==o?r-o:e<n?-1:1}),function(t,e){return n(function(t){return t.replace(y,"\n").replace(x,"").replace(P,"    ")}(t),e)}}(lt),dt=(Ot=function(t){return function(e,n,r){return t[e.type].p(e,n,r)}}(lt),function t(e,n={}){if(Array.isArray(e)){const r=n.g,o=[];let c=!1;for(let r=0;r<e.length;r++){n.g=r;const a=t(e[r],n),u="string"==typeof a;u&&c?o[o.length-1]+=a:null!==a&&o.push(a),c=u}return n.g=r,o}return Ot(e,t,n)});var Ot;const Bt=V(n);return nt.length?U("div",null,Bt,U("footer",{key:"footer"},nt.map(function(t){return U("div",{id:H.slugify(t.identifier),key:t.identifier},t.identifier,dt(ft(t.footnote,{o:!0})))}))):Bt}!function(t){t[t.MAX=0]="MAX",t[t.HIGH=1]="HIGH",t[t.MED=2]="MED",t[t.LOW=3]="LOW",t[t.MIN=4]="MIN"}(Mt||(Mt={}));/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (e=>{let{children:r,options:o}=e,c=function(t,e){if(null==t)return{};var n,r,o={},c=Object.keys(t);for(r=0;r<c.length;r++)e.indexOf(n=c[r])>=0||(o[n]=t[n]);return o}(e,n);return t.cloneElement(Ot(r,o),c)});
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 62276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(96948);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(43011);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 40335:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-ready",
      function () {
        return __webpack_require__(80252);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wE": function() { return /* binding */ useGetSoonestTimeByLocationsAndSpecialtyIds; },
/* harmony export */   "xz": function() { return /* binding */ getSortedSoonestLocationWithAvailableSlotBySpecialty; },
/* harmony export */   "zn": function() { return /* binding */ useGetSoonestInPracticeBySpecialtyId; }
/* harmony export */ });
/* unused harmony export getSoonestSlotFromApptSlotBlock */
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36330);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95832);
/* harmony import */ var _services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72714);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93932);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34557);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40367);
/* harmony import */ var _utils_fetchCachedSlotAround__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39815);
/* harmony import */ var _useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15343);











const getSoonestSlotFromApptSlotBlock = (slotTimes)=>{
    var _slotTimes_, _slotTimes__;
    return slotTimes === null || slotTimes === void 0 ? void 0 : (_slotTimes_ = slotTimes[0]) === null || _slotTimes_ === void 0 ? void 0 : (_slotTimes__ = _slotTimes_[0]) === null || _slotTimes__ === void 0 ? void 0 : _slotTimes__.time;
};
const useGetSoonestInPracticeBySpecialtyId = (param)=>{
    let { specialtyId , practiceId =_constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__/* .PracticeId.CARBON */ .I.CARBON , daysCount =7  } = param;
    const { pageLoaded , practices , locations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const [slot, setSlot] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const enableCache = (0,_useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlag */ .y)(_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__/* .FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */ .T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!pageLoaded || enableCache === undefined) return;
        if (enableCache) {
            (0,_utils_fetchCachedSlotAround__WEBPACK_IMPORTED_MODULE_9__/* .fetchCachedSlotAround */ .o)({
                locations,
                specialtyId
            }).then(setSlot);
        } else {
            var _locations_filter_;
            // @ts-expect-error TS2532: Object is possibly 'undefined'.
            const virtualSpecialtyIds = practices.flatMap((p)=>p.specialties.vals()).filter((s)=>s.isVirtual).map((s)=>s.id).distinct();
            const isVirtual = virtualSpecialtyIds.includes(specialtyId);
            // if virtual care, ignore closest location
            const closestLocationPracticeId = !isVirtual && ((_locations_filter_ = locations.filter((l)=>l.specialtyIds.includes(specialtyId))[0]) === null || _locations_filter_ === void 0 ? void 0 : _locations_filter_.practiceId);
            const finalPracticeId = practiceId || closestLocationPracticeId || _constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__/* .PracticeId.CARBON */ .I.CARBON;
            const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
            // @ts-expect-error TS2532, TS2684, TS2532: Object is possibly 'undefined'.,  The 'this' context of type 'RootStatePractice[] | undefined' is not assignable to method's 'this' of type 'RootStatePractice[]'.,  Object is possibly 'undefined'.
            const specialty = practices.findById(finalPracticeId).specialties[specialtyId] || {};
            const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = specialty;
            const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
            const to = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day");
            (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .loadAvailableSlots */ .vk)({
                practiceId: finalPracticeId,
                from,
                to,
                duration,
                specialtyId,
                timezone: _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .laTimezone */ .$A
            }).then((slots)=>{
                var _slots_;
                setSlot((slots === null || slots === void 0 ? void 0 : (_slots_ = slots[0]) === null || _slots_ === void 0 ? void 0 : _slots_[0]) || {});
            });
        }
    }, [
        pageLoaded,
        enableCache
    ]);
    return slot || null;
};
const useGetSoonestTimeByLocationsAndSpecialtyIds = (param)=>{
    let { locations , specialtyIds , daysCount =21 , specialtyCount =1 , locationCount =3  } = param;
    const { pageLoaded , locations: allLocations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return {
            ...config
        };
    });
    const selectedRegion = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)(src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_3__/* .selectSelectedRegion */ .dz);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [slotLocationWithTime, setSlotLocationWithTime] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const enableCache = (0,_useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlag */ .y)(_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__/* .FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */ .T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!pageLoaded || enableCache === undefined) return;
        const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
        (locations || allLocations.slice(0, locationCount)).map((l)=>{
            const sortedSpecialties = l.specialties.vals().sortBy("sortIndex").slice(0, specialtyCount);
            return (specialtyIds || sortedSpecialties.map((s)=>s.id) // if specialIds param is null, try with first specialtyId
            ).map((sId)=>{
                const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = l.specialties[sId] || {};
                const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
                return (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .loadAvailableSlots */ .vk)({
                    practiceId: l.practiceId,
                    locationId: l.id,
                    from,
                    to: +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day"),
                    duration,
                    specialtyId: sId,
                    timezone: l.timezone || _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .laTimezone */ .$A,
                    enableCache
                }).then((slotTimes)=>({
                        lId: l.id,
                        sId,
                        slotTime: getSoonestSlotFromApptSlotBlock(slotTimes)
                    }));
            }).sequence();
        }).sequence().then((locationsAndSlot)=>{
            setSlotLocationWithTime(locationsAndSlot.flat().groupBy("lId").mapValues((slots)=>slots.groupBy("sId").mapValues((slots)=>slots[0].slotTime)));
        });
    }, [
        pageLoaded,
        router.asPath,
        selectedRegion,
        enableCache
    ]);
    return slotLocationWithTime;
};
/* get first location with soonest specialty in location list
eg (assuming sf's urgentcare slot is sooner):
({locations: [berkeley, sf],specialtyId: UrgentCareId}) => {locationId: [sfLocationId]: time: 1666666} */ const getSortedSoonestLocationWithAvailableSlotBySpecialty = (param)=>{
    let { locationsWithSlots , specialtyId  } = param;
    if (locationsWithSlots.isOEmpty()) {
        // @ts-expect-error TS2322: Type 'null' is not assignable to type 'string'.
        return {
            locationId: null
        };
    }
    return locationsWithSlots.toArray()// @ts-expect-error TS2571: Object is of type 'unknown'.
    .sortBy((l)=>l[1][specialtyId])// @ts-expect-error TS2571: Object is of type 'unknown'.
    .map((l)=>({
            locationId: l[0],
            time: l[1][specialtyId]
        }))[0];
};


/***/ }),

/***/ 80252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ covid_ready; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1989);
// EXTERNAL MODULE: ./src/hooks/useFaqIndex.tsx + 2 modules
var useFaqIndex = __webpack_require__(47924);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
// EXTERNAL MODULE: ./src/components/v5/CovidReady3/Completed.module.scss
var Completed_module = __webpack_require__(34222);
var Completed_module_default = /*#__PURE__*/__webpack_require__.n(Completed_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/Completed.tsx





const Completed = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const data = [
        i18n.t("Film"),
        i18n.t("Sports"),
        i18n.t("Manufacturing"),
        i18n.t("Schools"),
        i18n.t("Healthcare"),
        i18n.t("Transportation"),
        i18n.t("Retail"),
        i18n.t("Logistics")
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Completed_module_default()).wrap,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Completed_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Completed_module_default()).head,
                    children: i18n.t("Over 2 million COVID-19 tests and 1.5 million vaccines administered")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (Completed_module_default()).icon,
                    children: data.map((d)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Completed_module_default()).iconInner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cIcon-".concat(d.toLocaleLowerCase(), " ").concat((Completed_module_default()).iconIcon)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((Completed_module_default()).iconTitle),
                                    children: d
                                })
                            ]
                        }, d))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                    className: "".concat((Completed_module_default()).start, " bg-white gray800"),
                    href: "#signup",
                    children: i18n.t("Talk to Our Team")
                })
            ]
        })
    });
};
/* harmony default export */ var CovidReady3_Completed = (/*#__PURE__*/react.memo(Completed));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scrollmagic/dist/index.es.js
var index_es = __webpack_require__(84690);
// EXTERNAL MODULE: ./src/components/v5/CovidReady3/Header.module.scss
var Header_module = __webpack_require__(14757);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/Header.tsx










const Header = (param)=>{
    let { getStartedTracker  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [id, setId] = (0,react.useState)(null);
    const [h, setH] = (0,react.useState)(1000);
    (0,react.useEffect)(()=>{
        (0,Carbon/* dly */.h7)(()=>{
            const layout = document.getElementById("layout");
            // @ts-expect-error TS2531: Object is possibly 'null'.
            setH(layout.offsetHeight);
        }, 0);
    }, []);
    const items = [
        {
            id: 1,
            title: i18n.t("How It Works"),
            link: "#how",
            dotColor: palette.yellow
        },
        {
            id: 2,
            title: i18n.t("Resources"),
            link: "#resources",
            dotColor: palette.purple
        },
        {
            id: 3,
            title: i18n.t("Testing"),
            link: "#servicesWrap",
            dotColor: palette.mint
        },
        {
            id: 4,
            title: i18n.t("Pricing"),
            link: "#pricing",
            dotColor: palette.mint
        },
        {
            id: 5,
            title: i18n.t("FAQ"),
            link: "#faq",
            dotColor: palette.blue
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Header_module_default()).outerWrap,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Controller */.Q, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Scene */.x, {
                triggerHook: 0,
                offset: 1,
                triggerElement: "#layout",
                duration: h,
                indicators: _constants/* dev */.WI,
                classToggle: "stick",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Header_module_default()).wrap,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: {
                                pathname: _constants/* v5Pages.home */.Td.home
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((Header_module_default()).l, " cIcon-covidReadyLogo"),
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Covid Ready by Carbon Health"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Header_module_default()).r, " basic ").concat(id ? "hoveredParent" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Header_module_default()).rInner,
                                    children: items.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: a.link,
                                            className: "".concat((Header_module_default()).r1, " ").concat(a.id === id ? "hoveredA" : ""),
                                            style: {
                                                "--dotColor": a.dotColor
                                            },
                                            // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'SetStateAction<null>'.
                                            onMouseEnter: ()=>setId(a.id),
                                            onMouseLeave: ()=>setId(null),
                                            children: a.title
                                        }, a.id))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Header_module_default()).r2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                        href: "#signup",
                                        color: palette.gray800,
                                        bg: palette.gray50,
                                        hover: palette.gray50,
                                        hoverBg: palette.gray800,
                                        fontSize: "14px",
                                        className: (Header_module_default()).r22,
                                        onClick: getStartedTracker,
                                        children: i18n.t("Get started")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CovidReady3_Header = (Header);

// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/Hero.tsx






const Hero = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pos-r dg ph4 pt24-md ph0-md pb4-md bg-darkerBlue bgcov bgpc minh180 minh0-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                src: "/covidReady3/hero",
                layout: "fill",
                priority: true,
                objectFit: "cover",
                className: "h100p obfc",
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pos-r maxw75 w100p ph4 ma dg aic h100p",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "white mt4 maxw30",
                            children: i18n.t("Get your workforce COVID Ready")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "white mt0 fs20 maxw36",
                            children: i18n.t("Keep your employees safe with COVID-19 testing, tracking, vaccines, medical protocols and more.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            href: "#signup",
                            color: palette.gray800,
                            bg: palette.gray50,
                            hoverBg: palette.gray200,
                            className: "mt8",
                            children: i18n.t("Talk to Our Team")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CovidReady3_Hero = (Hero);

// EXTERNAL MODULE: ./src/components/v5/CovidReady3/How.module.scss
var How_module = __webpack_require__(75398);
var How_module_default = /*#__PURE__*/__webpack_require__.n(How_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/How.tsx






const How = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const data = [
        {
            icon: "monitor-plus",
            title: i18n.t("Management & Containment"),
            body: i18n.t("Get updates on employees’ COVID-19 test results through your customized employer dashboard. Should any of your employees exhibit symptoms, we have step-by-step plans in place and medical staff who are able to advise on next steps.")
        },
        {
            icon: "flu-screening",
            title: i18n.t("Testing & Vaccinations"),
            body: i18n.t("We can provide COVID-19 testing onsite, in one of our nationwide clinics, or administer them at home. We also offer COVID-19 vaccinations and boosters in our clinics and at onsite events.")
        },
        {
            icon: "conversation-chat-bubble",
            title: i18n.t("Medical Protocols"),
            body: i18n.t("Our medical team provides COVID-19 workplace protocols and operational best practices grounded in scientific research, so you can stay safe in and out of work.")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (How_module_default()).wrap,
        id: "how",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (How_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tac mb24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: (How_module_default()).head1,
                            children: i18n.t("How it works")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (How_module_default()).head2,
                            children: i18n.t("Minimize workplace risk")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (How_module_default()).subHead,
                            children: i18n.t("Testing is not enough. Make sure you have all the pieces in place to safely and responsibly open and operate.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            className: (How_module_default()).start,
                            bg: palette.darkGreen,
                            href: "#signup",
                            children: i18n.t("Talk to Our Team")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "dg mt12 gtc3fr af-md maxw36-md ma gg8 mb12",
                    children: data.map((d)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((How_module_default()).fIcon, " cIcon-").concat(d.icon)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: (How_module_default()).fHead,
                                    children: d.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (How_module_default()).fSub,
                                    children: d.body
                                })
                            ]
                        }, d.icon))
                })
            ]
        })
    });
};
/* harmony default export */ var CovidReady3_How = (/*#__PURE__*/react.memo(How));

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(32216);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./src/useV5ImgSrc.tsx
var useV5ImgSrc = __webpack_require__(52299);
// EXTERNAL MODULE: ./src/components/v5/CovidReady3/Partners.module.scss
var Partners_module = __webpack_require__(57632);
var Partners_module_default = /*#__PURE__*/__webpack_require__.n(Partners_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/Partners.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 





const heights = [
    15,
    58,
    37,
    60,
    60
];
const Partners = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Partners_module_default()).wrap,
        id: "partners",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Partners_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: (Partners_module_default()).head,
                    children: i18n.t("These Partners are COVID Ready")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Partners_module_default()).partners,
                    children: range_default()(5).map((l, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,useV5ImgSrc/* useV5ImgSrc */.eH)("/covidReady3/partners".concat(i)),
                            alt: "partner".concat(i),
                            height: heights[i]
                        }, i))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                    className: (Partners_module_default()).copy,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cIcon-quote"
                        }),
                        i18n.t("We were impressed with Carbon Health’s sharp focus on COVID-19 and data, and have partnered with them to provide tools to keep our employees safe as we build back to a better future.")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Partners_module_default()).who,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).who1,
                            children: i18n.t("Sholeh Esmaili-Montoya")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).who2,
                            children: i18n.t("Vice President of People & Places")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Partners_module_default()).who2,
                            children: i18n.t("Bolt Threads")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CovidReady3_Partners = (/*#__PURE__*/react.memo(Partners));

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(62276);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/v5/CovidReady3/CovidReadyForm.module.scss
var CovidReadyForm_module = __webpack_require__(47006);
var CovidReadyForm_module_default = /*#__PURE__*/__webpack_require__.n(CovidReadyForm_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/CovidReadyForm.tsx








const CovidReadyForm = (param)=>{
    let { handleSubmit , submitting , error  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { recaptchaClientKey  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const recaptchaRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (CovidReadyForm_module_default()).form,
        onSubmit: async (e)=>{
            e.preventDefault();
            // @ts-expect-error TS2531: Object is possibly 'null'.
            const captcha = await recaptchaRef.current.executeAsync();
            handleSubmit(e, captcha);
        },
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "red bold",
                children: "Something went wrong. Please refresh the page and try again"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CovidReadyForm_module_default()).twoCols,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "fname",
                        className: (CovidReadyForm_module_default()).field,
                        required: true,
                        placeholder: i18n.t("First name"),
                        defaultValue: _constants/* dev */.WI ? "goksel" : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "lname",
                        className: (CovidReadyForm_module_default()).field,
                        required: true,
                        placeholder: i18n.t("Last name"),
                        defaultValue: _constants/* dev */.WI ? "eryigit" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                className: (CovidReadyForm_module_default()).field,
                required: true,
                placeholder: i18n.t("Company name"),
                defaultValue: _constants/* dev */.WI ? "carbon" : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "email",
                className: (CovidReadyForm_module_default()).field,
                required: true,
                placeholder: i18n.t("Work email address"),
                defaultValue: _constants/* dev */.WI ? "goksel@carbonhealth.com" : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "tel",
                className: (CovidReadyForm_module_default()).field,
                placeholder: i18n.t("Phone number"),
                defaultValue: _constants/* dev */.WI ? "000-000-0000" : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CovidReadyForm_module_default()).submitR,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                        type: "submit",
                        fontSize: "14px",
                        className: "bg-darkGreen",
                        children: i18n.t("Contact Our Team")
                    }),
                    submitting && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CovidReadyForm_module_default()).saving,
                        children: i18n.t("saving...")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                ref: recaptchaRef,
                sitekey: recaptchaClientKey,
                size: "invisible"
            })
        ]
    });
};
/* harmony default export */ var CovidReady3_CovidReadyForm = (CovidReadyForm);

// EXTERNAL MODULE: ./src/components/v5/CovidReady3/Signup.module.scss
var Signup_module = __webpack_require__(5291);
var Signup_module_default = /*#__PURE__*/__webpack_require__.n(Signup_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidReady3/Signup.tsx





const Signup = (props)=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { industryList , submitted  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Signup_module_default()).wrap,
        id: "signup",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Signup_module_default()).n,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Signup_module_default()).n0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Signup_module_default()).n00,
                        children: industryList.map((s)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Signup_module_default()).n000,
                                children: s
                            }, s))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Signup_module_default()).n1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Signup_module_default()).n10,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (Signup_module_default()).n100,
                                children: i18n.t("Sign up now")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Signup_module_default()).n1000,
                                children: [
                                    submitted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Signup_module_default()).sub,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "".concat((Signup_module_default()).sub0, " cIcon-ok2")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Signup_module_default()).sub1,
                                                children: i18n.t("Thank you. Someone from our Covid Ready team will be in touch with you soon.")
                                            })
                                        ]
                                    }),
                                    !submitted && /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_CovidReadyForm, {
                                        ...props
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CovidReady3_Signup = (Signup);

// EXTERNAL MODULE: ./src/components/v5/Faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(73349);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./node_modules/color/index.js
var node_modules_color = __webpack_require__(32130);
var color_default = /*#__PURE__*/__webpack_require__.n(node_modules_color);
// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./src/hooks/useGetSoonestTime.ts
var useGetSoonestTime = __webpack_require__(46102);
// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
// EXTERNAL MODULE: ./src/components/v5/Services.module.scss
var Services_module = __webpack_require__(37332);
var Services_module_default = /*#__PURE__*/__webpack_require__.n(Services_module);
;// CONCATENATED MODULE: ./src/components/v5/ServicesTimedCarousel.tsx


/* eslint-disable react-hooks/rules-of-hooks */ // @ts-expect-error TS7016: Could not find a declaration file for module 'color'. '/Users/goksel/Sites/carbon-website-next/node_modules/color/index.js' implicitly has an 'any' type.













const time = 5000;
const timeSec = "".concat(time / 1000, "s");
/**
 * @param noBtns When true, buttons will not be rendered for each service and no API calls will be made to retrieve appointment slots.
 * If you pass the `noBtns` prop, you should not pass `locations`, `practices`, or `selectedRegion`,
 * Otherwise, these are required.
 * @param reverse If true, places the images on the left and services on the right
 * @param locationsSorted (IF DEFAULT SLIDES) Used to determined if scheduling redirect url uses preselected location ids
 * @param practices  (IF DEFAULT SLIDES) getVirtualSpecialtyIds() will be called on practices for scheduling redirect url
 */ const ServicesTimedCarousel = (param)=>{
    let { header , customSlides , noBtns , reverse , innerStyle , practiceId  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile , practices , locationsSorted , locations  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const defaultSlides = [
        {
            specialtyId: specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE,
            head: i18n.t("Primary Care"),
            text: i18n.t("From preventive care to chronic issues, our primary care providers partner with you for all your healthcare needs."),
            color: "#58B3CA",
            btnColor: "#fff",
            btnBgColor: palette.blue,
            btnText: i18n.t("Book appointment"),
            img: "services_caro0",
            href: (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
                practiceId: practiceId || practiceIds/* PracticeId.CARBON */.I.CARBON,
                specialtyId: specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE
            })
        },
        {
            specialtyId: specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE,
            head: i18n.t("Urgent Care"),
            text: i18n.t("Fast, same-day care for illnesses and injuries from sudden fevers and stomach upsets to cuts, rashes and sprains."),
            color: palette.yellow,
            btnColor: palette.gray800,
            btnBgColor: palette.yellow,
            btnText: i18n.t("Book appointment"),
            img: "services_caro1",
            href: (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
                practiceId: practiceId || practiceIds/* PracticeId.CARBON */.I.CARBON,
                specialtyId: specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE
            })
        },
        {
            head: i18n.t("Virtual Care"),
            text: i18n.t("Virtual primary care, urgent care, and mental health visits - all delivered online from the comfort of your home."),
            color: palette.mint,
            btnColor: palette.gray800,
            btnBgColor: palette.mint,
            btnText: i18n.t("Start"),
            img: "services_caro2",
            href: (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
                practiceId: practiceId || practiceIds/* PracticeId.CARBON */.I.CARBON,
                virtual: true,
                // @ts-expect-error TS2345: Argument of type 'RootStatePractice[] | undefined' is not assignable to parameter of type 'RootStatePractice[]'.
                specialtyId: (0,Carbon/* getVirtualSpecialtyIds */.wH)(practices)
            })
        }
    ];
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [delay, setDelay] = (0,react.useState)(time);
    const [pause, setPause] = (0,react.useState)(true);
    const [slides, setSlides] = (0,react.useState)(customSlides || defaultSlides);
    const startTime = Date.now();
    const activeSlide = slides[activeIndex];
    const slotsData = (0,useGetSoonestTime/* useGetSoonestTimeByLocationsAndSpecialtyIds */.wE)({
        // @ts-expect-error TS2322: Type '(SpecialtyId | undefined)[]' is not assignable to type 'SpecialtyId[]'.
        specialtyIds: slides.map((s)=>s.specialtyId)
    });
    const closesetLocationsWithPrimaryCare = (0,useGetSoonestTime/* useGetSoonestInPracticeBySpecialtyId */.zn)({
        specialtyId: specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE
    });
    const closesetLocationsWithUrgentCare = (0,useGetSoonestTime/* useGetSoonestInPracticeBySpecialtyId */.zn)({
        specialtyId: specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE
    });
    (0,react.useEffect)(()=>{
        if (!locationsSorted || noBtns) return;
        setPause(false);
        const newSlides = slides.map((s)=>{
            const slide = s;
            if (slide.specialtyId === specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE) // @ts-expect-error TS2532, TS2684: Object is possibly 'undefined'.,  The 'this' context of type 'RootStateLocation[] | undefined' is not assignable to method's 'this' of type 'RootStateLocation[]'.
            slide.location = locations.findById(closesetLocationsWithUrgentCare.locationId);
            else if (slide.specialtyId === specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE) // @ts-expect-error TS2532, TS2684: Object is possibly 'undefined'.,  The 'this' context of type 'RootStateLocation[] | undefined' is not assignable to method's 'this' of type 'RootStateLocation[]'.
            slide.location = locations.findById(closesetLocationsWithPrimaryCare.locationId);
            return slide;
        });
        setSlides(newSlides);
    }, [
        locationsSorted
    ]);
    if (!isMobile) {
        (0,Carbon/* useInterval */.Yz)(()=>{
            setActiveIndex((activeIndex + 1) % slides.length);
        }, delay, pause);
    }
    (0,react.useEffect)(()=>{
        setDelay(time);
    }, [
        activeIndex
    ]);
    const images = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pos-r desktopOnly",
        children: slides.map((s, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Services_module_default()).rightImg, " ").concat(i === activeIndex ? "on" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    src: s.img,
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "0 75%",
                    alt: ""
                })
            }, s.head))
    });
    const renderContent = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((Services_module_default()).wrap, " dg gac bg-smoke pos-r"),
            id: "servicesWrap",
            children: [
                reverse && images,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((Services_module_default()).inner, " tac"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((Services_module_default()).leftInner),
                        style: innerStyle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "".concat((Services_module_default()).header, " gray400"),
                                children: header || i18n.t("Our Services")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt4 dn db-md tac",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                    src: activeSlide.img,
                                    height: 400,
                                    width: 400 * 0.8,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Services_module_default()).rows,
                                onMouseEnter: ()=>{
                                    const timeLeft = delay - (Date.now() - startTime);
                                    setDelay(timeLeft);
                                    setPause(true);
                                },
                                onMouseLeave: ()=>{
                                    setPause(false);
                                },
                                children: slides.map((param, i)=>{
                                    let { location , specialtyId , head , text , color , btnColor , btnBgColor , btnText , isNew , href , btn1 , btn2  } = param;
                                    // @ts-expect-error TS2538: Type 'undefined' cannot be used as an index type.
                                    const firstSlot = !noBtns ? slotsData[specialtyId].vals().min() : undefined;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((Services_module_default()).row, " ").concat(activeIndex === i ? "active" : ""),
                                        children: [
                                            locationsSorted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Services_module_default()).rowSpinner,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "spinerContainer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "pie spinner",
                                                            style: {
                                                                "--bg": color,
                                                                "--time": timeSec,
                                                                "--state": pause ? "paused" : "running"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "pie filler",
                                                            style: {
                                                                "--bg": color,
                                                                "--time": timeSec,
                                                                "--state": pause ? "paused" : "running"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mask",
                                                            style: {
                                                                "--time": timeSec,
                                                                "--state": pause ? "paused" : "running"
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Services_module_default()).rowHeadContainer, " df aic"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "".concat((Services_module_default()).rowHead, " fs24-md"),
                                                        onClick: ()=>setActiveIndex(i),
                                                        children: head
                                                    }),
                                                    isNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((Services_module_default())["new"], " newLabel"),
                                                        children: i18n.t("NEW")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Services_module_default()).rowBody),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "color-nevada fs20 lh12 mt4 lh15 font-ir fs16-md",
                                                        children: text
                                                    }),
                                                    !noBtns && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "dig aic mt4 gg8 gg4-md",
                                                            children: [
                                                                location ? // @ts-expect-error TS2322: Type 'string | undefined' is not assignable to type 'Url'.
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: href,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "button",
                                                                        className: "".concat((Services_module_default()).btn, " btn bold-f"),
                                                                        style: {
                                                                            "--color": btnColor,
                                                                            "--btnBgColor": btnBgColor || color,
                                                                            "--btnHoverBg": color_default()(btnBgColor || color).darken(0.2)
                                                                        },
                                                                        children: btnText
                                                                    })
                                                                }) : locationsSorted && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: href,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: ()=>(0,Carbon/* trackToPatient */.Zr)(),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "button",
                                                                        className: "".concat((Services_module_default()).btn, " btn bold-f"),
                                                                        style: {
                                                                            "--color": btnColor,
                                                                            "--btnBgColor": btnBgColor || color,
                                                                            "--btnHoverBg": color_default()(btnBgColor || color).darken(0.2)
                                                                        },
                                                                        children: btnText
                                                                    })
                                                                }),
                                                                firstSlot && specialtyId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "fs14 color-nevada ",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "desktopOnly",
                                                                            children: i18n.t("Next at")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "color-default medium ml1",
                                                                            children: (0,Carbon/* todayTomorrow2 */.mE)(i18n.lang, firstSlot)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    (btn1 || btn2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "dig aic mt4 gg2 gg4-md",
                                                            children: [
                                                                btn1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                                                    color: btn1.color,
                                                                    bg: btn1.bgColor,
                                                                    href: btn1.url,
                                                                    fontSize: "12px",
                                                                    children: btn1.title
                                                                }),
                                                                btn2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                                                    color: btn2.color,
                                                                    bg: btn2.bgColor,
                                                                    href: btn2.url,
                                                                    fontSize: "12px",
                                                                    children: btn2.title
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, head);
                                })
                            })
                        ]
                    })
                }),
                !reverse && images
            ]
        });
    return renderContent();
};
/* harmony default export */ var v5_ServicesTimedCarousel = (ServicesTimedCarousel);

// EXTERNAL MODULE: ./src/utils/transparent.ts
var transparent = __webpack_require__(74355);
;// CONCATENATED MODULE: ./src/pages/covid-ready.tsx




















const getStartedTracker = ()=>{
    (0,api.GA)({
        category: "Carbon Ready",
        action: "Self Serve Lead Form",
        label: "Start Registration"
    });
};
const CovidReady = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { csrfToken  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const industryList = [
        "Aerospace & Defense",
        "Agriculture",
        "Apparel",
        "Banking",
        "Biotechnology",
        "Business Services",
        "Communications",
        "Construction",
        "Consulting",
        "Delivery & Logistics",
        "Education",
        "Electronics",
        "Energy",
        "Engineering",
        "Entertainment & Media",
        "Environmental",
        "Film",
        "Financial Services",
        "Food & Beverage",
        "Government",
        "Healthcare",
        "Hospitality",
        "Insurance",
        "Machinery",
        "Manufacturing",
        "Medical Device",
        "Not For Profit",
        "Other",
        "Pharmaceutical",
        "Public Services",
        "Real Estate",
        "Recreation",
        "Retail",
        "Shipping",
        "Technology",
        "Telecommunications",
        "Transportation",
        "Travel",
        "Utilities"
    ];
    const faq = (0,useFaqIndex/* useFaqIndex */.l)([
        "How does COVID Ready work?",
        "How do employees onboard through the Carbon Health app?",
        "Which test is used to test employees for COVID-19?",
        "Can employers see an employee's private medical information?",
        "What employee information is being tracked?",
        "Is employee data protected?",
        "Can employees control what data is shared?",
        "How does Carbon perform Employee Contact Tracing?",
        "How does Carbon do Workplace Contact Tracing?",
        "What protections does Carbon have in place to protect my personal and health information from hackers or outsiders getting into the app or into their databases that store my information?",
        "Where do they store this information?",
        "Is there any user agreement, consent forms, or any document that I can review before I even download the app and provide my personal and health information to another company?",
        "How long does Carbon keep personal/health data for?",
        "Is there anything that describes what they are doing, will do, and are allowed to do with my information?",
        "Can I delete the app AND my personal and health information and history if necessary?",
        "How long are we expected to be monitored and provide info to this app?"
    ]);
    const servicesProps = {
        noBtns: true,
        header: i18n.t("COVID-19 Testing"),
        reverse: true,
        customSlides: [
            {
                head: i18n.t("Onsite Testing"),
                text: i18n.t("Enjoy the convenience of high volume testing events at your work location. Carbon Health will coordinate with your team(s) to conduct onsite COVID-19 testing of all employees. Results are tracked and monitored in a customized employer dashboard."),
                img: "covidReady3/services0",
                color: "#59b3ca",
                btn2: {
                    title: i18n.t("Contact Our Team"),
                    color: palette.gray800,
                    bgColor: (0,transparent/* transparent */.Z)(palette.gray800, 5),
                    url: "#signup"
                }
            },
            {
                head: i18n.t("In-Clinic Testing"),
                text: i18n.t("Pre schedule appointments at Carbon Health clinics for quick turnaround times and shorter wait periods. Ideal for small numbers of employees needing regular scheduled testing to return to work."),
                img: "covidReady3/services1",
                color: "#59b3ca",
                btn2: {
                    title: i18n.t("Contact Our Team"),
                    color: palette.gray800,
                    bgColor: (0,transparent/* transparent */.Z)(palette.gray800, 5),
                    url: "#signup"
                }
            },
            {
                head: i18n.t("At-Home Testing"),
                text: i18n.t("Opt to have your employees test from the comfort and safety of their own homes. Perfect for companies operating in multiple locations with distributed teams."),
                img: "covidReady3/services2",
                color: "#59b3ca",
                btn2: {
                    title: i18n.t("Contact Our Team"),
                    color: palette.gray800,
                    bgColor: (0,transparent/* transparent */.Z)(palette.gray800, 5),
                    url: "#signup"
                }
            }
        ],
        innerStyle: {
            paddingTop: "7rem"
        }
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const [submitted, setSubmitted] = (0,react.useState)(false);
    const [submitting, setSubmitting] = (0,react.useState)(false);
    const [linkedinConversionId, setLinkedinConversionId] = (0,react.useState)(null);
    const [error, setError] = (0,react.useState)(false);
    // @ts-expect-error TS7006, TS7006: Parameter 'e' implicitly has an 'any' type.,  Parameter 'captcha' implicitly has an 'any' type.
    const handleSubmit = async (e, captcha)=>{
        setSubmitting(true);
        const FirstName = e.target[0].value;
        const LastName = e.target[1].value;
        const Company = e.target[2].value;
        const Email = e.target[3].value;
        const Phone = e.target[4].value;
        (0,api/* addToSalesforce */.u)(csrfToken, {
            FirstName,
            LastName,
            Company,
            Email,
            Phone,
            LeadSource: "web",
            captcha
        }).then(()=>{
            (0,Carbon/* trackToPatient */.Zr)({
                ga: {
                    category: "Carbon Ready",
                    action: "Enterprise Lead Form",
                    label: Company
                }
            });
            // @ts-expect-error TS2345: Argument of type '2747490' is not assignable to parameter of type 'SetStateAction<null>'.
            setLinkedinConversionId(_constants/* c4BLinkedInConversionId */.et);
            setSubmitted(true);
            setSubmitting(false);
        }).catch(()=>{
            setSubmitted(false);
            setSubmitting(false);
            return setError(true);
        });
    };
    (0,Carbon/* useEffectAsync */.LX)(async ()=>{
        dispatch(store/* actions.setConfig */.Nw.setConfig({
            pageLoaded: true
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("COVID Ready: Keep your employees safe and healthy"),
        pageDescription: i18n.t("Carbon Health offers COVID-19 testing, tracking, vaccines, and more."),
        noHeader: true,
        pageImage: "covid-ready",
        children: [
            linkedinConversionId && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                height: "1",
                width: "1",
                style: {
                    display: "none"
                },
                alt: "",
                src: "https://px.ads.linkedin.com/collect/?pid=2265524&conversionId=".concat(linkedinConversionId, "&fmt=gif")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_Header, {
                getStartedTracker
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_Partners, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_How, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_Completed, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_ServicesTimedCarousel, {
                ...servicesProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidReady3_Signup, {
                csrfToken,
                getStartedTracker,
                handleSubmit,
                submitted,
                submitting,
                industryList,
                error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                faq: faq
            })
        ]
    });
};
/* harmony default export */ var covid_ready = (CovidReady);


/***/ }),

/***/ 34222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Completed_wrap__8FlJJ","inner":"Completed_inner__1k9Mb","head":"Completed_head__IyCh1","icon":"Completed_icon__jDdpH","iconIcon":"Completed_iconIcon__tOaU3","iconTitle":"Completed_iconTitle__semDJ","start":"Completed_start__X72DE"};

/***/ }),

/***/ 47006:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sub":"CovidReadyForm_sub__jDJP2","form":"CovidReadyForm_form__gWkO2","twoCols":"CovidReadyForm_twoCols__OHp7u","field":"CovidReadyForm_field__J8Gaj","ddown":"CovidReadyForm_ddown__RmEtl","employees":"CovidReadyForm_employees__SeSaS","hidden":"CovidReadyForm_hidden__Z6TBL","submitR":"CovidReadyForm_submitR__StkU4","saving":"CovidReadyForm_saving___Pk2p","submit":"CovidReadyForm_submit__wfO53"};

/***/ }),

/***/ 14757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerWrap":"Header_outerWrap__JzsxZ","wrap":"Header_wrap__La7dZ","l":"Header_l__9ks1d","r1":"Header_r1__BTLJn","l2":"Header_l2__6aucS","l3":"Header_l3__2MpOe","l4":"Header_l4__VRsl6","l5":"Header_l5__c2Vz_","r":"Header_r__cK8Ra","rInner":"Header_rInner__dLDxE","r2":"Header_r2__8biH1"};

/***/ }),

/***/ 75398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"How_wrap__G9Z1_","inner":"How_inner__c4C39","head1":"How_head1__JZ8YT","head2":"How_head2__sevcF","subHead":"How_subHead__pLBS8","start":"How_start__Icu5Y","fIcon":"How_fIcon__vKmAX","fHead":"How_fHead__igzgr","fSub":"How_fSub__ryR0q","f":"How_f__63G8N"};

/***/ }),

/***/ 57632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Partners_wrap__2Ue3y","inner":"Partners_inner__uNEYi","head":"Partners_head__wycNg","partners":"Partners_partners__rRW67","copy":"Partners_copy__sxyQe","who":"Partners_who__X_Y0g","who1":"Partners_who1__zDcMI","who2":"Partners_who2__cEviC"};

/***/ }),

/***/ 5291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Signup_wrap__922Tt","n":"Signup_n__BaGjX","n0":"Signup_n0__NNNQh","n00":"Signup_n00__ww8Fl","n000":"Signup_n000__ymf22","n1":"Signup_n1__Rm30X","n10":"Signup_n10__78c_i","n1000":"Signup_n1000__whX9S","sub":"Signup_sub__mTbRT"};

/***/ }),

/***/ 37332:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Services_wrap__AB66c","inner":"Services_inner__nCY1r","leftInner":"Services_leftInner__5o5Kd","header":"Services_header__eBH_T","rightImg":"Services_rightImg__uGVmE","rows":"Services_rows__CvhXq","row":"Services_row__qzSty","rowSpinner":"Services_rowSpinner__UthJE","rowHeadContainer":"Services_rowHeadContainer__va5Sf","rowHead":"Services_rowHead__27cZu","rowBody":"Services_rowBody__Ov3zt","new":"Services_new__lfwJp","btn":"Services_btn__DGYIA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,2493,4690,6282,2122,620,9774,2888,179], function() { return __webpack_exec__(40335); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);